export default __webpack_public_path__ + "img/dAZOIBBz.baf15b8d.svg";